export function sortAscElements(a, b) {
    return parseInt(a.fields.order.value) - parseInt(b.fields.order.value);
}
export function sortDescElements(a, b) {
    return parseInt(b.fields.order.value) - parseInt(a.fields.order.value);
}
